"use client";

import Link from "next/link";
import { Plus } from "lucide-react";
import TextGenerateEffect from "@/components/TextGenerateEffect";
import { RevealGroup, RevealItem } from "@/components/RevealStack";
import BLOG_POSTS from "@/app/blog/data";

export default function BlogIndexPage() {
  const [featured, ...rest] = BLOG_POSTS;

  return (
    <main className="bl-page">
      <section className="bl-hero" data-bg-tint="peach">
        <TextGenerateEffect
          as="h1"
          words="Expert Insights."
          className="bl-hero-title"
          duration={0.9}
          staggerDelay={0.07}
          filter={false}
        />

        <div className="bl-hero-sub">
          <div className="bl-hero-tag">
            <Plus size={16} strokeWidth={2.5} aria-hidden />
            <span>Journal</span>
          </div>
          <p className="bl-hero-lead">
            <strong>Stories from surgery, the game table, and the pursuit of mastery </strong>
            <span>across disciplines.</span>
          </p>
          <p className="bl-hero-aside">
            From championship runs to neurosurgical breakthroughs — the latest
            from Dr. Burak Ozgur.
          </p>
        </div>
      </section>

      <RevealGroup as="section" className="bl-grid" data-bg-tint="lilac">
        <RevealItem className="bl-feature-wrap">
          <Link
            href={`/blog/${featured.slug}`}
            className="bl-card bl-card--feature"
          >
            <div className="bl-card-bg">
              <img src={featured.image} alt="" />
              <div className="bl-card-bg-overlay" />
            </div>
            <div className="bl-feature-foot">
              <div className="bl-feature-date">{featured.dateLabel}</div>
              <h2 className="bl-feature-title">{featured.title}</h2>
              <p className="bl-feature-excerpt">{featured.excerpt}</p>
            </div>
          </Link>
        </RevealItem>

        {rest.map((post) => (
          <RevealItem key={post.slug}>
            <Link href={`/blog/${post.slug}`} className="bl-card">
              <div className="bl-card-thumb">
                <img src={post.image} alt="" />
              </div>
              <button
                type="button"
                className="bl-card-plus"
                aria-hidden
                tabIndex={-1}
              >
                <Plus size={16} strokeWidth={2.5} />
              </button>
              <div className="bl-card-body">
                <div className="bl-card-date">{post.dateLabel}</div>
                <h3 className="bl-card-title">{post.title}</h3>
                <p className="bl-card-excerpt">{post.excerpt}</p>
              </div>
            </Link>
          </RevealItem>
        ))}
      </RevealGroup>
    </main>
  );
}
